module.exports = __webpack_public_path__ + "static/media/test17_3.1a8d1afa.png";